import { Link } from "react-router-dom";
import { PlateMark } from "@/components/PlateMark";

type Props = {
  /** When true, no link wrapper (used on the home page to avoid self-link). */
  asStatic?: boolean;
};

export const Logo = ({ asStatic }: Props) => {
  const inner = (
    <span className="flex items-center gap-2">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
        <PlateMark className="h-5 w-5" />
      </span>
      <span className="font-display text-xl font-semibold tracking-tight">
        CleanPlate
      </span>
    </span>
  );
  if (asStatic) return inner;
  return (
    <Link to="/" className="transition-smooth hover:opacity-80">
      {inner}
    </Link>
  );
};
